export default {
  id: "topSellingCategories",
  name: "",
  description: "",
  report: {
    name: "Top Selling Categories",
    chartType: "TABLE",
    template: "custom",
    config: {
      dataType: "single",
      dataSet: "Category",
      dimensions: ["Category.name"],
      measures: ["SaleItem.units_sold"],
      sort: {
        direction: "desc",
        by: "SaleItem.units_sold",
      },
      filters: [
        {
          member: "Category.name",
          operator: "set",
        },
      ],
      compare: true,
      limit: "10",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
    },
  },
};
